module.exports = __webpack_public_path__ + "2a3f89b335717925f1b5694168b47aed.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/Profile_Pic_Overlay_1.png
// module id = 157
// module chunks = 0